import { z } from 'zod';
import { DISPOSAL_PURPOSE_SCHEMA, FREIGHT_TYPE_SCHEMA } from '@schuettflix/interfaces';

export type FreightTypeUnionParams = {
    errorMessages?: { required?: string };
};

export function getFreightTypeUnion(params?: FreightTypeUnionParams) {
    const { errorMessages } = params ?? {};

    return z.discriminatedUnion('freightType', [
        z.object({
            freightType: FREIGHT_TYPE_SCHEMA.exclude(['NON_HAZARDOUS_WASTE', 'HAZARDOUS_WASTE']),
        }),
        z.object({
            freightType: FREIGHT_TYPE_SCHEMA.extract(['NON_HAZARDOUS_WASTE']),
            disposalPurpose: z.enum(DISPOSAL_PURPOSE_SCHEMA.options, { required_error: errorMessages?.required }),
        }),
        z.object({
            freightType: FREIGHT_TYPE_SCHEMA.extract(['HAZARDOUS_WASTE']),
            disposalPurpose: z.enum(DISPOSAL_PURPOSE_SCHEMA.options, { required_error: errorMessages?.required }),
            disposalCertificateNumber: z.string().optional(),
        }),
    ]);
}
